import React, { useState, useRef } from 'react';
import './IntegrationPrompt.less';
import { EnabledPromptDisplayData } from '@decisions/server/DecisionsFramework/Design/Flow/EnabledPromptDisplayData';
import { DesignerPromptLayer } from './DesignerPromptLayer';
import { Button } from 'components/buttons';

export interface IEnabledPromptProps extends EnabledPromptDisplayData {
  getEditingContextId?: () => Promise<string>;
  onClose?: () => void;
}

export function EnabledPrompt({
  Title,
  Enabled,
  getEditingContextId,
  onClose,
}: IEnabledPromptProps) {
  const [isLayerVisible, setIsLayerVisible] = useState<boolean>(false);
  const ref: React.MutableRefObject<HTMLElement | any> = useRef(null);

  return (
    <div ref={ref} className="dp-enabled-prompt">
      {!Enabled && (<div className='dp-enabled-prompt__icon' />)}
      <Button
      className="dp-enabled-prompt__link"
      variant="link"
      dropdown
      onClick={() => setIsLayerVisible(true)}
      textTransform="capitalize"
      dropDownOpened={isLayerVisible}
      >
        {Title}
      </Button>
      {isLayerVisible && (
        <DesignerPromptLayer
          category='Enabled'
          getEditingContextId={getEditingContextId}
          onClose={() => {
            setIsLayerVisible(false);
            onClose && onClose();
          }}
          sourceRef={ref}
        />
      )}
    </div>
  );
}
